// extracted by mini-css-extract-plugin
module.exports = {"root":"Note_root__2J_01","info":"Note_info__1qtOL","note":"Note_note__3l3QT","actions":"Note_actions__2OCmx"};